import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

const projects = [
  {
    image: 'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/56af3dcab4b0c79f2407d7ad80cbcfbd.jpeg',
    category: 'Spa Inspired Bathroom',
    title: 'Spa Inspired Bathroom',
    slug: 'spa-inspired-bathroom',
    description: 'Transform your bathroom into a luxurious spa retreat with premium fixtures and elegant design.',
  },
  {
    image: 'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/6b46caaf1cd883cf1307dbc4375bbce9.jpeg',
    category: 'Bathroom',
    title: 'Bathroom',
    slug: 'bathroom',
    description: 'Complete bathroom renovations with modern fixtures, custom tile work, and expert craftsmanship.',
  },
  {
    image: 'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/bbd1645db457b8f35c143a5d651b873c.jpeg',
    category: 'Shower',
    title: 'Shower',
    slug: 'shower',
    description: 'Custom shower installations featuring glass enclosures, premium tile, and modern fixtures.',
  },
  {
    image: 'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/738a4d5a587ef2ba6a74ad1dfea30f03.jpeg',
    category: 'Basement',
    title: 'Basement Renovation',
    slug: 'basement',
    description: 'Transform your basement into functional living space with professional finishing and design.',
  },
  {
    image: 'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/d025fe4cc0484d5595dcfb67cf704735.jpeg',
    category: 'Kitchen',
    title: 'Kitchen Renovation',
    slug: 'kitchen',
    description: 'Stunning kitchen remodels with custom cabinetry, countertops, and modern appliances.',
  },
  {
    image: 'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/5bd444f6e80012b0e9c8d582b091676c.jpeg',
    category: 'Laundry Room',
    title: 'Laundry Room',
    slug: 'laundry-room',
    description: 'Efficient and stylish laundry room designs with smart storage solutions and modern finishes.',
  },
];

export default function Projects() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <main className="flex-1 bg-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-12">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Our Projects
            </h1>
            <p className="text-gray-600 text-xl">
              Browse our portfolio of completed renovations and transformations
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <Link
                key={index}
                to={`/gallery/${project.slug}`}
                className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer block"
              >
                <div className="relative w-full h-96">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover object-top transition-all duration-300"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-all duration-300"></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent pointer-events-none">
                  <span className="inline-block bg-teal-600 text-white px-4 py-1 rounded-full text-sm font-semibold mb-2 whitespace-nowrap">
                    {project.category}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="text-center text-white px-6">
                    <h3 className="text-2xl font-bold mb-2">{project.title}</h3>
                    <p className="text-white/90 text-sm mb-4">{project.description}</p>
                    <span className="inline-flex items-center space-x-2 text-lg font-semibold whitespace-nowrap">
                      <span>View Project</span>
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}